<script setup>
  import { ref, computed } from 'vue';

  import SubAccordion from './SubAccordion.vue';

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const props = defineProps({
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    openByDefault: {
      type: Boolean,
      default: false
    }
  });

  const isOpen = ref(props.openByDefault);

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  const hasChildren = computed(() => {
    return props.item.childs && Array.isArray(props.item.childs) && props.item.childs.length > 0;
  });

  const relevantFiles = computed(() => {
    return props.item.files && Array.isArray(props.item.files) ? props.item.files : [];
  });

  const hasFiles = computed(() => {
    return relevantFiles.value.length > 0;
  });

  const openFile = (url) => {
    window.open(url, '_blank');
  };
</script>

<template>
  <div :class="['accordion-item', `level-${level}`]">
    <div
      :class="['accordion-header', `level-${level}-header`, { 'is-open': isOpen && level === 0 }]"
      @click="toggle"
    >
      <h4>{{ item.name }}</h4>
      <span class="icon">{{ isOpen ? '&#8722;' : '&#43;' }}</span>
    </div>

    <div :class="['accordion-content', `level-${level}-content`, { 'open': isOpen }]">
      <div class="accordion-content-inner">
        <div v-if="hasFiles" class="file-list">
          <ul>
            <li v-for="file in relevantFiles" :key="file.id">
              <a :href="file.url" target="_blank" rel="noopener noreferrer">
                {{ file.name }} ({{ file.size }})
              </a>
              <div class="file-actions">
                <a :href="file.url" target="_blank" rel="noopener noreferrer" class="preview-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                       stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye">
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0
                0 1-19.876 0"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </a>
                <a :href="file.url" :download="file.name" title="Download" class="download-link">
                  Download
                </a>
              </div>

            </li>
          </ul>
        </div>

        <div v-if="hasChildren" class="nested-accordions">
          <SubAccordion
            v-for="childItem in item.childs"
            :key="childItem.id"
            :item="childItem"
            :level="level + 1"
            :open-by-default="openByDefault"
          />
        </div>

        <p v-if="!hasFiles && !hasChildren" class="no-content">
          {{ trans("No files or subcategories available for this item.") }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .level-0-header{
    border-bottom: 1px solid #D9D9D9;
    border-top: 1px solid #D9D9D9;
  }

  .level-0-header.is-open {
    background-color: #F5F5F5;
  }
</style>
